// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12LXs","colBig":"styles_colBig__aPZzo","colSmall":"styles_colSmall__3M2N1"};